import { ChangeDetectorRef, Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subject, debounceTime, partition } from "rxjs";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { RestrictedAccessComponent } from "../restricted-access/restricted-access.component";
import { DataService } from "src/app/Services/dataservice.service";
import { MatSelectionListChange } from "@angular/material/list";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { hasContentCreationPlanAccess } from "src/app/shared/utils/plan.util";

@Component({
  selector: "app-transfer-ownership",
  templateUrl: "./transfer-ownership.component.html",
  styleUrls: ["./transfer-ownership.component.scss"],
})
export class TransferOwnershipComponent implements OnInit, AfterViewInit {
  allUsers: any;
  tempUsers: any;
  userData: any;
  profilePicture: string;
  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  showDefaultImage: boolean;
  input!: string;
  isdisabled: boolean;
  flowModel: any;
  _steps: any[];
  coverImageUri: string;
  stepsImageUri: string;
  stepDescription: string;
  title: string;
  CategoryName: string;
  inames: any[];
  accessType: string;
  description: string;
  userDisplayName: any;
  showUsers: boolean = false;
  noResultReturned: boolean;
  flowData: any;
  flowCoverImageUrl: any;
  private searchTerms = new Subject<string>();
  selectedUser: any;
  progress: number;
  transferComment: string = "";

  // Pagination properties
  currentPage: number = 1;
  usersPerPage: number = 5;
  totalPages: number = 1;
  startIndex: number = 0;
  endIndex: number = 0;
  paginatedUsers: any[] = [];
  visiblePageNumbers: (number | string)[] = [];

  // Search state property
  isSearching: boolean = false;

  // Create flow mode flag
  isCreateFlowMode: boolean = false;
  ownerPlanBlocked: boolean = false;

  // ViewChild references for focus management
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  @ViewChild('usersList', { static: false }) usersList: ElementRef;

  constructor(
    private userserviceService: UserserviceService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    public dialogRef: MatDialogRef<TransferOwnershipComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Check if opened from create-flow mode
    if (this.data && this.data.isCreateFlowMode) {
      this.isCreateFlowMode = true;
      this.flowModel = this.data.flowData;
    } else {
      this.flowModel = JSON.parse(localStorage.getItem("flowModel"));
    }

    this.searchTerms
      .pipe(debounceTime(2000)) // Adjust the debounce time as needed
      .subscribe(() => {
        // Call your search function here
        this.performUsersSearch(0);
      });
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.flowData = JSON.parse(localStorage.getItem("flowModel"));
    this.flowCoverImageUrl = "url(" + '"' + this.flowData.url + '"' + ")";
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }

    if (!hasContentCreationPlanAccess(this.userData)) {
      this.ownerPlanBlocked = true;
      this.toastr.info(
        "A Creator or Business plan is required to transfer ownership."
      );
      setTimeout(() => this.dialogRef.close(false), 0);
      return;
    }

    localStorage.getItem("flowmodel");
    //
    this.allUsers = [];
    this.tempUsers = [];
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    // Get profile user first to set email, then load initial users
    this.getProfileUser();
  }

  ngAfterViewInit() {
    // Focus management for accessibility
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
      }
    }, 100);
  }

  // New method to load initial users
  loadInitialUsers() {
    this.isSearching = true; // Show loading state initially
    this.getPaginatedUsers(undefined, "0");
  }

  onSelectionChange(event: MatSelectionListChange) {
    const selected = event.options.find((option) => option.selected)?.value;
    // Prefer the inner user object if present
    this.selectedUser = selected && selected.user ? selected.user : selected;
    // Ensure compatibility with legacy template fields
    if (this.selectedUser) {
      if (!this.selectedUser.EmailAddress && this.selectedUser.emailAddress) {
        this.selectedUser.EmailAddress = this.selectedUser.emailAddress;
      }
      if (!this.selectedUser.UserName && this.selectedUser.userName) {
        this.selectedUser.UserName = this.selectedUser.userName;
      }
      if (!this.selectedUser.ProfilePicUrl && this.selectedUser.profilePicUrl) {
        this.selectedUser.ProfilePicUrl = this.selectedUser.profilePicUrl;
      }
    }
  }

  titleChanged(): void {
    // Method to handle title changes - can be extended for validation if needed
    console.log("Transfer comment changed:", this.transferComment);
  }

  performUsersSearch(pageIndex) {
    this.noResultReturned = true;
    this.allUsers = [];
    this.tempUsers = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      this.showUsers = false;
      email = this.userData.emailAddress;
    }
    this.showUsers = true;
    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
      contentCreationPlanOnly: true,
    });

    this.userserviceService.searchInUsers(flowQueryModel).subscribe({
      next: (data) => {
        this.noResultReturned = false;

        if (data.allUsers && data.allUsers.length > 0) {
          this.tempUsers = [];
          this.allUsers = [];
          this.filterEligibleUsers(data.allUsers).forEach((element) => {
            console.log(element);
            const user = {
              user: element,
              showFollow: false,
              UserName: element.userName,
              followButtonText: element.followingText,
              EmailAddress: element.emailAddress,
            };
            this.allUsers.push(user);
          });

          this.tempUsers = this.allUsers;
          console.log(this.tempUsers);
          this.tempUsers.forEach((element) => {
            if (element.followButtonText === "Following") {
              element.followButtonText = "Following";
              element.followingcolor = "black";
              element.followingbgcolor = "white";
            } else {
              element.followButtonText = "Follow";
              element.followingcolor = "white";
              element.followingbgcolor = "#5ea1d8";
            }
          });
          this.updatePagination(); // Update pagination after search results
        } else {
          this.tempUsers = [];
          this.allUsers = [];
          this.updatePagination();
        }
        // After search completes, set isSearching to false
        this.isSearching = false;
      },
      error: (error) => {
        console.error("Error searching users:", error);
        this.noResultReturned = false;
        this.tempUsers = [];
        this.allUsers = [];
        this.isSearching = false;
        this.updatePagination();
      },
    });
  }
  getPaginatedUsers(infiniteScroll, pageIndex) {
    var email = "";

    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
      contentCreationPlanOnly: true,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performUsersSearch(pageIndex);
    } else {
      this.userserviceService.getAllUsers(flowQueryModel).subscribe({
        next: (data) => {
          if (data.allUsers && data.allUsers.length > 0) {
            this.tempUsers = [];
            this.allUsers = [];
            this.filterEligibleUsers(data.allUsers).forEach((element) => {
              const user = {
                FlowId: element.rowKey,
                user: element,
                UserName: element.userName,
                ProfilePicUrl: element.profilePicUrl,
                FirstName: element.firstName,
                EmailAddress: element.emailAddress,
                showFollow: false,
                followButtonText: element.followingText,
              };
              this.allUsers.push(user);
            });
            this.tempUsers = this.allUsers;
            console.log(this.tempUsers);
            this.tempUsers.forEach((element) => {
              if (element.followButtonText === "Following") {
                element.followButtonText = "Following";
                element.followingcolor = "black";
                element.followingbgcolor = "white";
              } else {
                element.followButtonText = "Follow";
                element.followingcolor = "white";
                element.followingbgcolor = "#5ea1d8";
              }
            });
            this.showUsers = true;
            this.isSearching = false; // Hide loading state
            this.updatePagination(); // Update pagination after users are loaded
          } else {
            this.tempUsers = [];
            this.allUsers = [];
            this.showUsers = false;
            this.isSearching = false; // Hide loading state
            this.updatePagination();
          }
        },
        error: (error) => {
          console.error("Error loading users:", error);
          this.tempUsers = [];
          this.allUsers = [];
          this.showUsers = false;
          this.isSearching = false; // Hide loading state
          this.updatePagination();
        },
      });
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }
  publish() {
    this.noResultReturned = true;
    if (this.userData != null && this.selectedUser.EmailAddress) {
      this.flowModel.isOwnershipTransfered = true;
      this.flowModel.oldOwner = this.flowData.customerEmail;
      this.flowModel.customerEmail = this.selectedUser.EmailAddress;
      this.flowModel.searchKeyWords =
        Array.isArray(this.flowModel.searchKeyWords) &&
        this.flowModel.searchKeyWords.length > 0
          ? this.flowModel.searchKeyWords.join(", ")
          : "";

      this.flowServiceService
        .publishUserFlow(this.flowModel, this.userData.emailAddress)
        .subscribe({
          next: (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                console.log("Request sent to server.");
                break;

              case HttpEventType.UploadProgress:
                this.progress = Math.round(
                  (95 * event.loaded) / (event.total || 1)
                );
                console.log(`Progress: ${this.progress}%`);
                break;

              case HttpEventType.Response:
                this.cdr.detectChanges();

                setTimeout(() => {
                  this.progress = 100;
                  this.dialogRef.close(true);
                  this.noResultReturned = false;
                  this.toastr.success("Successfully transfered the ownership");
                  this.resetProgress();
                }, 2000);

                break;

              default:
                console.log("Unhandled event:", event);
            }
          },
          error: (err) => {
            console.error("Error uploading:", err);
            this.showTransferPlanError(err, "Failed to transfer ownership");
            this.resetProgress();
          },
        });
    }
  }
  requestToTransferOwnerShip() {
    console.log(this.selectedUser);
    this.noResultReturned = true;
    const selectedEmail =
      this.selectedUser?.EmailAddress || this.selectedUser?.emailAddress;
    const selectedUserName =
      this.selectedUser?.UserName ||
      this.selectedUser?.userName ||
      this.selectedUser?.user?.userName;
    if (selectedEmail == this.flowData.customerEmail) {
      this.toastr.info(
        "Ownership transfer cannot be made to a user who is already the owner."
      );
      this.close();
    }
    if (
      this.userData != null &&
      selectedEmail &&
      selectedEmail != this.flowData.customerEmail
    ) {
      const request = {
        requestStatus: "Pending",
        contentId: this.flowData.rowKey,
        statusMessage:
          this.transferComment || "Ownership transfer request initiated.",
        contentName: this.flowData.title,
        partitionKey: this.flowData.rowKey,
        contentType: this.flowData.type == "Bundle" ? "Bundle" : "Flow",
        newOwnerEmail: selectedEmail,
        newOwnerUserName: selectedUserName,
        oldOwnerUserName: this.flowData.userName,
        oldOwnerEmail: this.flowData.customerEmail,
        isActive: true,
        updatedDateTime: new Date().toISOString(),
        createdDateTime: new Date().toISOString(),
      };

      this.flowServiceService
        .postTransferOwnership(request, this.userData.emailAddress)
        .subscribe({
          next: (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                console.log("Request sent to server.");
                break;

              case HttpEventType.UploadProgress:
                this.progress = Math.round(
                  (95 * event.loaded) / (event.total || 1)
                );
                console.log(`Progress: ${this.progress}%`);
                break;

              case HttpEventType.Response:
                console.log("Upload complete:", event.body);
                const data = event.body;
                if (data != null) {
                  this.progress = 100;
                  this.close();
                  this.noResultReturned = false;
                  this.toastr.success("Successfully transfered the ownership");
                  this.resetProgress();
                }

                break;

              default:
                console.log("Unhandled event:", event);
            }
          },
          error: (err) => {
            console.error("Error uploading:", err);
            this.showTransferPlanError(err, "Failed to send transfer ownership request");
            this.resetProgress();
          },
        });
    }
  }

  private filterEligibleUsers(users: any[]): any[] {
    const ownerEmail = (
      this.flowData?.customerEmail ||
      this.userData?.emailAddress ||
      ""
    )
      .toString()
      .trim()
      .toLowerCase();

    return users.filter((user) => {
      const email = (user.emailAddress || user.EmailAddress || "")
        .toString()
        .trim()
        .toLowerCase();
      if (ownerEmail && email === ownerEmail) {
        return false;
      }
      return hasContentCreationPlanAccess(user);
    });
  }

  private showTransferPlanError(err: any, fallbackMessage: string): void {
    const code = err?.error?.code;
    const message = err?.error?.message;
    if (
      code === "subscription_required" ||
      code === "recipient_subscription_required" ||
      code === "invalid_transfer_recipient"
    ) {
      this.toastr.info(message || fallbackMessage);
      return;
    }
    this.toastr.error(message || fallbackMessage);
  }

  resetProgress() {
    setTimeout(() => {
      this.progress = 0;
      this.noResultReturned = false;
    }, 500); // Small delay before hiding progress
  }
  close() {
    this.dialogRef.close(false);
  }

  /**
   * Close dialog and return selected user for create-flow component
   */
  closeWithSelectedUser() {
    if (this.selectedUser) {
      this.dialogRef.close({
        selectedUser: this.selectedUser,
        transferComment: this.transferComment,
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  viewUserProfile(selectedUser) {
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedUser.customerEmail ||
        this.userData.emailAddress === selectedUser.emailAddress
      ) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedUser);
    } else {
      this.router.navigate(["/login"]);
    }
  }

  searchUsers() {
    if (this.input && this.input.length > 0) {
      this.isSearching = true;
      this.searchTerms.next(this.input);

      // After search results are set, update pagination
      this.currentPage = 1; // Reset to first page on new search
      this.updatePagination();
    } else {
      // If search input is cleared, show initial users
      this.isSearching = false;
      this.loadInitialUsers();
      this.currentPage = 1;
      this.updatePagination();
    }
  }

  // Handle keyboard navigation
  onKeyDown(event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape':
        this.close();
        break;
      case 'Enter':
        if (this.selectedUser && !this.isSearching) {
          if (this.isCreateFlowMode) {
            this.closeWithSelectedUser();
          } else {
            this.confirmTransfer();
          }
        }
        break;
      case 'Tab':
        // Allow default tab behavior for accessibility
        break;
    }
  }

  // Handle touch events for better mobile interaction
  onTouchStart(event: TouchEvent) {
    // Prevent double-tap zoom on iOS
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.userserviceService.getProfileUser().subscribe({
        next: (data) => {
          if (
            data.userData.profilePicUrl === "" ||
            data.userData.profilePicUrl == null
          ) {
            this.showDefaultImage = true;
          } else {
            this.showDefaultImage = false;
            this.profilePicture = data.userData.profilePicUrl;
          }
          this.email = data.userData.emailAddress;
          this.phone = data.userData.phoneNumber;
          this.info = data.userData.info;
          this.website = data.userData.website;
          this.uname = data.userData.userName;
          this.name = data.userData.firstName;

          // Now that email is set, load initial users
          this.loadInitialUsers();
        },
        error: (error) => {
          console.error("Error getting profile:", error);
          // Even if profile fails, try to load users
          this.loadInitialUsers();
        },
      });
    } else {
      // If no user data, still try to load users
      this.loadInitialUsers();
    }
  }
  isConfirmed = false;
  showTransferConfirmation = false;

  confirmTransfer() {
    // Check if we have a selected user from the selection list
    if (!this.selectedUser) {
      this.toastr.warning("Please select a user for transfer ownership");
      return;
    }

    // Proceed with existing logic
    this.isConfirmed = true;
    this.showTransferConfirmation = false;
    if (this.selectedUser) {
      this.showTransferConfirmation = true;
      this.requestToTransferOwnerShip();
    }
  }

  // Pagination methods
  updatePagination() {
    if (!this.tempUsers || this.tempUsers.length === 0) {
      this.totalPages = 1;
      this.paginatedUsers = [];
      this.visiblePageNumbers = [];
      return;
    }

    this.totalPages = Math.ceil(this.tempUsers.length / this.usersPerPage);
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    this.currentPage = Math.max(this.currentPage, 1);

    this.startIndex = (this.currentPage - 1) * this.usersPerPage;
    this.endIndex = Math.min(
      this.startIndex + this.usersPerPage,
      this.tempUsers.length
    );

    this.paginatedUsers = this.tempUsers.slice(this.startIndex, this.endIndex);
    this.updateVisiblePageNumbers();
  }

  updateVisiblePageNumbers() {
    this.visiblePageNumbers = [];

    if (this.totalPages <= 7) {
      // Show all page numbers if 7 or fewer pages
      for (let i = 1; i <= this.totalPages; i++) {
        this.visiblePageNumbers.push(i);
      }
    } else {
      // Show smart pagination with ellipsis
      if (this.currentPage <= 4) {
        // Near the beginning
        for (let i = 1; i <= 5; i++) {
          this.visiblePageNumbers.push(i);
        }
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        // Near the end
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.totalPages - 4; i <= this.totalPages; i++) {
          this.visiblePageNumbers.push(i);
        }
      } else {
        // In the middle
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++) {
          this.visiblePageNumbers.push(i);
        }
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      }
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  goToPage(page: number | string) {
    if (typeof page === "number" && page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
    }
  }

  changeUser() {
    this.selectedUser = null;
    this.transferComment = "";
  }
}
